import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    gridContainer: {
        display: "grid",
        gap: theme.spacing(3),
        gridTemplateColumns: "calc(25% - 9px) calc(25% - 9px) calc(25% - 9px) calc(25% - 9px)",
        gridTemplateRows: "calc(50% - 6px) calc(50% - 6px)",
        height: "calc(100vh - 222px)",
        width: "100vw",
        boxSizing: "border-box",
        padding: theme.spacing(6),
    },
    weekTrendWrapper: {
        gridColumn: "5/2",
    },
    cardHeader: {
        minHeight: theme.spacing(13),
    },
    cardHeaderActions: {
        minWidth: theme.spacing(20),
        display: "flex",
        justifyContent: "flex-end",
    },
}));
